import { toast } from "react-toastify";

export const exportOrders = async (filters, fileName) => {
    return await exportData('/shipping-method/export', filters, fileName);
  };
export const exportOrdersData = async (route,filters, fileName) => {
    return await exportData(route, filters, fileName);
  };
export const exportShippingMethods = async (filters, fileName) => {
    return await exportData('/shipping-method/export', filters, fileName);
  };
export const exportMethods = async (filters, fileName,route) => {
    return await exportData(route, filters, fileName);
  };
  
  function getExportFileName(name) {
    const baseName = name.replace(/\.[^/.]+$/, '');
    
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${yyyy}${mm}${dd}`;

    return `${baseName}_${formattedDate}.xlsx`;
  }
  
  export const exportData = async (
    route,
    filters,
    fileName = 'Orders_export.xlsx'
  ) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
      const token = JSON.parse(localStorage.getItem('token'));      
      const queryParams = new URLSearchParams();
      // for (const key in filters) {
      //   if (filters[key] !== undefined && filters[key] !== null) {
      //     queryParams.append(key, filters[key]);
      //   }
      // }
      
      // if (Array.isArray(idsStatus)) {
      //   idsStatus.forEach((id) => queryParams.append('ids[]', id));
      // }
      // if(searchQuery!==''){
      //   queryParams.append('search', searchQuery);
      // }


      if (Array.isArray(filters.ids)) {
        filters.ids.forEach((id) => queryParams.append('ids[]', id));
      } else if (filters.ids) {
        queryParams.append('ids[]', filters.ids);
      } 
      if (Array.isArray(filters?.brandIds)) {
        filters?.brandIds.forEach((id) => queryParams.append('brands[]', id));
      } else if (filters?.brandIds) {
        queryParams.append('brands[]', filters?.brandIds);
      }
      if (Array.isArray(filters?.categoryIds)) {
        filters?.categoryIds.forEach((id) => queryParams.append('category_ids[]', id));
      } else if (filters?.categoryIds) {
        queryParams.append('category_ids[]', filters?.categoryIds);
      }
      if (Array.isArray(filters?.originIds)) {
        filters?.originIds.forEach((id) => queryParams.append('origin_ids[]', id));
      } else if (filters?.originIds) {
        queryParams.append('origin_ids[]', filters?.originIds);
      }
      if (Array.isArray(filters?.productIds)) {
        filters?.productIds.forEach((id) => queryParams.append('product_ids[]', id));
      } else if (filters?.productIds) {
        queryParams.append('product_ids[]', filters?.productIds);
      }
      if (Array.isArray(filters?.customerGroupIds)) {
        filters?.customerGroupIds.forEach((id) => queryParams.append('customer_group_ids[]', id));
      } else if (filters?.customerGroupIds) {
        queryParams.append('customer_group_ids[]', filters?.customerGroupIds);
      }
      if (Array.isArray(filters?.picStaffMemberImport)) {
        filters?.picStaffMemberImport.forEach((id) => queryParams.append('pic_staff_member_import[]', id));
      } else if (filters?.picStaffMemberImport) {
        queryParams.append('pic_staff_member_import[]', filters?.picStaffMemberImport);
      }
      if (Array.isArray(filters?.picStaffMemberSales)) {
        filters?.picStaffMemberSales.forEach((id) => queryParams.append('pic_staff_member_sales[]', id));
      } else if (filters?.picStaffMemberSales) {
        queryParams.append('pic_staff_member_sales[]', filters?.picStaffMemberSales);
      }
   
      // Append other filters parameters
      Object.keys(filters).forEach((key) => {
        if (key !== 'ids') {
          queryParams.append(key, filters[key]);
        }
      });



      const urlWithParams = `${apiUrl}${route}?${queryParams.toString()}`;
      
      const response = await fetch(urlWithParams, {
        method: 'GET',
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer ' + token, // Using the token in Authorization header
        },
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const contentDisposition = response.headers.get('Content-Disposition');
  
      if (contentDisposition) {
        const matches = contentDisposition.match(/filename="(.+)"/);
        if (matches && matches[1]) {
          fileName = matches[1];
        }
      }
  
      const blob = await response.blob();
  
      const link = document.createElement('a');
      const fileURL = URL.createObjectURL(blob);
  
      link.href = fileURL;
      link.download = getExportFileName(fileName);
  
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      URL.revokeObjectURL(fileURL);
    } catch (error) {
      toast.error('Something went wrong')
      console.error('Error downloading file:', error);
    }
  };
  export const exportDirectInOut  = async (
    queryParams,
 
  ) => {
    try {
    const fileName = 'direct_inout_table.xlsx'

      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
      const token = JSON.parse(localStorage.getItem('token'));      
     

     
      const url = `${apiUrl}/direct_in_out/v2`;
      
      const response = await fetch(url, {
        method: 'POST',
        body:queryParams,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer ' + token, // Using the token in Authorization header
        },
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.includes('application/json')) { 
        const result = await response.json();
        if (!result.success) {
          throw new Error(result.msg || 'API returned an error');
        }
        // Handle the success case if JSON is expected (optional here)
      }
     
      // const contentDisposition = response.headers.get('Content-Disposition');
  
      // if (contentDisposition) {
      //   const matches = contentDisposition.match(/filename="(.+)"/);
      //   if (matches && matches[1]) {
      //     fileName = matches[1];
      //   }
      // }
  
      const blob = await response.blob();
  
      const link = document.createElement('a');
      const fileURL = URL.createObjectURL(blob);
  
      link.href = fileURL;
      link.download = getExportFileName(fileName);
  
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      URL.revokeObjectURL(fileURL);
    } catch (error) {
      // toast.error('Something went wrong')
      toast.error(error.message)
      console.error('Error downloading file:', error);
    }
  };
  export const exportPrepackInOut  = async (
    queryParams,
 
  ) => {
    try {
    const fileName = 'prepack_inout_table.xlsx'

      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
      const token = JSON.parse(localStorage.getItem('token'));      
     

     
      const url = `${apiUrl}/prepack_in_out`;
      
      const response = await fetch(url, {
        method: 'POST',
        body:queryParams,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer ' + token, // Using the token in Authorization header
        },
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.includes('application/json')) { 
        const result = await response.json();
        if (!result.success) {
          throw new Error(result.msg || 'API returned an error');
        }
        // Handle the success case if JSON is expected (optional here)
      }
     
      // const contentDisposition = response.headers.get('Content-Disposition');
  
      // if (contentDisposition) {
      //   const matches = contentDisposition.match(/filename="(.+)"/);
      //   if (matches && matches[1]) {
      //     fileName = matches[1];
      //   }
      // }
  
      const blob = await response.blob();
  
      const link = document.createElement('a');
      const fileURL = URL.createObjectURL(blob);
  
      link.href = fileURL;
      link.download = getExportFileName(fileName);
  
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      URL.revokeObjectURL(fileURL);
    } catch (error) {
      // toast.error('Something went wrong')
      toast.error(error.message)
      console.error('Error downloading file:', error);
    }
  };
  // export const exportData = async (
  //   route,
  //   filters,
  //   fileName = 'Orders_export.xlsx'
  // ) => {
  //   try {
  //     const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
  //     const token = JSON.parse(localStorage.getItem('token'));      
  //     const queryParams = new URLSearchParams();
  //     for (const key in filters) {
  //       if (filters[key] !== undefined && filters[key] !== null) {
  //         queryParams.append(key, filters[key]);
  //       }
  //     }

      
  //     const urlWithParams = `${apiUrl}${route}?${queryParams.toString()}`;
      
  //     const response = await fetch(urlWithParams, {
  //       method: 'GET',
  //       headers: {
  //         accept: 'application/json',
  //         Authorization: 'Bearer ' + token, // Using the token in Authorization header
  //       },
  //     });
  
  //     if (!response.ok) {
  //       throw new Error('Network response was not ok');
  //     }
  
  //     const contentDisposition = response.headers.get('Content-Disposition');
  
  //     if (contentDisposition) {
  //       const matches = contentDisposition.match(/filename="(.+)"/);
  //       if (matches && matches[1]) {
  //         fileName = matches[1];
  //       }
  //     }
  
  //     const blob = await response.blob();
  
  //     const link = document.createElement('a');
  //     const fileURL = URL.createObjectURL(blob);
  
  //     link.href = fileURL;
  //     link.download = fileName;
  
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  
  //     URL.revokeObjectURL(fileURL);
  //   } catch (error) {
  //     console.error('Error downloading file:', error);
  //   }
  // };